import { render, staticRenderFns } from "./WxPunch.vue?vue&type=template&id=6722b360&scoped=true&"
import script from "./WxPunch.vue?vue&type=script&lang=js&"
export * from "./WxPunch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6722b360",
  null
  
)

export default component.exports